import { NextSeo } from 'next-seo';
import BookkeepingPage from '_components/composed/pages/BookkeepingPage';

export default function Bookkeeping() {
  return (
    <>
      <NextSeo
        title="Expert Bookkeeping Services by Incorpified - Focus on Your Business"
        description="Maintain financial accuracy with Incorpified’s Bookkeeping services. Our experts handle your bookkeeping needs, allowing you to focus on your business."
      />
      <BookkeepingPage />
    </>
  );
}
